import { MapfreLoadingComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { HeaderComponent } from '../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import { AlertService } from '@mapfre-design-library/src/public_api';
import { AuthenticationService } from '../../_services/_iam/authentication-service.service';
import { User } from '@models/user';
import { UserService } from '../../_services/user.service';
import { ClientCredentialsService } from '../../_services/client-credentials/client-credentials.service';
import { ClientCredentialsTokenService } from '../../_services/client-credentials/client-credentials-token.service';
import { ErrorRedirectionService } from '../../_services/error-service/error-redirection.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreLoadingComponent],
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
})
export class VerifyAccountComponent implements OnInit {
  user: User;

  constructor(
    private activatedRoute: ActivatedRoute,
    private _cookieService: CookieService,
    private alertService: AlertService,
    private authService: AuthenticationService,
    private router: Router,
    private userService: UserService,
    private clientCredentialsService: ClientCredentialsService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private errorRedirectionService: ErrorRedirectionService
  ) {}

  validateToken(email: string, token: string) {
    if (!email || !token) {
      return null;
    }
    return this.authService
      .verifyAccountTokenVerification(token, email)
      .subscribe(
        () => {
          this.alertService.success('THANKS_FOR_VALIDATING_ACCOUNT', true);
          this._cookieService.deleteAll();
          this.router.navigate(['login']);
        },
        (error) => {
          if (error.status == 403 || error.status == 400) {
            this.router.navigate(['/opps/link-expire']);
          } else {
            this.errorRedirectionService.redirect(error.status);
          }
        }
      );
  }

  ngOnInit() {
    if (!this.clientCredentialsTokenService.getToken()) {
      this.clientCredentialsService.getToken().subscribe(
        () => {
          this.userService.$user.subscribe((user) => {
            this.user = user;
          });
          this.activatedRoute.queryParams.subscribe((params) => {
            if (params) {
              if (this.user == undefined) {
                this.user = params;
              }
              return this.validateToken(params.email, params.token);
            }
          });
        },
        (errorRes) => {
          if (errorRes.status) {
            this.errorRedirectionService.redirect(errorRes.status);
          }
        }
      );
    }
  }
}
